import CoinsSection from "./CoinsSection";
import GameTitle from "./GameTitle";
import LevelSection from "./LevelSection";

export default function Header({
  coins,
  level,
  onHint,
  menuOpen,
  setMenuOpen,
}) {


  return (
    <div className='container-fluid'>
      <div className="flex justify-between">
        <div className='d-flex justify-content-between align-items-center'>
          <div className="col-md-3">

          </div>
          <div className="col-md-6">
            <GameTitle />

          </div>
          <div className="col-md-3 d-flex align-items-center">
            <div className="score-box">
              <CoinsSection coins={coins} />
              <img className='score-btn' src={`${process.env.PUBLIC_URL}/assets/images/puzzle/score.png`} alt="Score" title="Score" />
            </div>
            <LevelSection level={level} />
            <img
              onClick={(e) => {
                e.stopPropagation();
                setMenuOpen(true);
                onHint();
              }}
              className="hint-btn"
              src={`${process.env.PUBLIC_URL}/assets/images/puzzle/hint.png`}
              alt="Hint"
              title="Hint"
            />

          </div>

        </div>
      </div>
    </div>
  );
}